import * as i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

import { getAssetURL } from 'lib/utility/GetAssetUrl'

i18n
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'en',
    defaultNS: 'common',
    otherLanguages: ['fr-CA'],
    whitelist: ['en', 'fr-CA'],

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },

    backend: {
      loadPath: getAssetURL('/locales/{{lng}}/{{lng}}.json'),
    },
  })

export default i18n
